import { baseApi } from "./baseApi";

// Mirrors what the backend GET /api/stats/status actually returns
// (routes/user/userStats.ts). It sends raw values, not derived booleans —
// derive birthdaySet / birthdayToday on the client from `birthday`.
export interface UserStatus {
  emailVerified: boolean;
  /** ISO date string, or null when the user hasn't set a birthday */
  birthday: string | null;
  /** the user's signature emoji, or null/undefined when unset */
  emoji?: string | null;
  badges: number;
}

export interface SetBirthdayRequest {
  birthDate: string;
}

export const statusApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserStatus: builder.query<UserStatus, void>({
      query: () => "/stats/status",
      providesTags: ["Status"],
    }),
    setBirthday: builder.mutation<void, SetBirthdayRequest>({
      query: (body) => ({
        url: "/stats/birthday",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Status"],
    }),
  }),
  overrideExisting: false,
});

export const { useGetUserStatusQuery, useSetBirthdayMutation } = statusApi;
